import { version } from './version';

export const environment = {
  production: true,
  SHORT_URL: 'w.winwithdash.com',
  local: false,
  BASE_PATH: 'https://api.winwithdash.com/v4',
  ASSETS_URL: 'https://assets.winwithdash.com',
  DASH_WEB: 'https://fans.winwithdash.com',
  PUBLISH_KEY: 'pub-c-f4e822f7-550d-462a-ab87-a1a867cc3e75',
  SUBSCRIBE_KEY: 'sub-c-8626c0dc-4bf6-11e5-b316-0619f8945a4f',
  RAVEN_CONFIG: 'https://d5a69e2fc60d47eca261c8c1adef5ba0@sentry.io/1225208',
  appId: 'dash',
  version,
  mixpanelToken: 'f9cda7ad9c7b15c7e0fde063159fc845',
};
